<script lang="ts" setup>
import type { FormActions, TypedSchema } from 'vee-validate'
import { useForm } from 'vee-validate'
import { provide, toRef, watch } from 'vue'
import { FORM_PROCESSING_INJECTION_KEY } from './injectionKeys'

const props = withDefaults(
  defineProps<{
    validationSchema?: TypedSchema<any>
    values?: Record<string, any>
    processing?: boolean
  }>(),
  {
    processing: false,
  },
)

const emit = defineEmits<{
  (e: 'submit', data: { values: Record<string, any>, setErrors: FormActions<Record<string, any>>['setErrors'], resetForm: FormActions<Record<string, any>>['resetForm'] }): void
  (e: 'invalidSubmit', data: { values: Record<string, any> }): void
}>()

const { handleSubmit, resetForm, values } = useForm({
  validationSchema: toRef(props, 'validationSchema'),
  keepValuesOnUnmount: true,
})

watch(() => props.values, (values) => {
  resetForm({ values }, {
    force: true,
  })
}, { immediate: true })

const onSubmit = handleSubmit(
  (values, ctx) => {
    emit('submit', { values, setErrors: ctx.setErrors, resetForm: ctx.resetForm })
  },
  ({ values }) => {
    emit('invalidSubmit', { values })
  },
)

provide(FORM_PROCESSING_INJECTION_KEY, toRef(props, 'processing'))
</script>

<template>
  <form @submit.prevent="onSubmit">
    <slot :submit-form="onSubmit" :values />
  </form>
</template>
